import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { IRoleResponseBase } from '@/core/interfaces/ApiResponses';


export default /*#__PURE__*/_defineComponent({
  __name: 'DanhSachRoleTable',
  props: {
    items: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    "max-height": "800",
    style: {"width":"100%"},
    size: "medium",
    border: true,
    data: _ctx.items,
    "empty-text": "không có vai trò để hiển thị"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "ID",
        width: "60"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.id), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { label: "Tên vai trò" }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.name), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { label: "Sô quyền hạn" }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.permissions.length), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})